import React, {useState, useEffect, useCallback, useRef} from 'react'
import {Input,  Image, message, Button, Space} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import DraggableModal from "../../components/DraggableModal";
import PicUploader from "../../components/Uploader";
import JobFairApi from "../../api/jobfair";
import {emptyValidate} from "../../util/validate";

export default function LineModal({onClose,onRemove, isShow, data={}}) {
    const [isOpen, setIsOpen] = useState(false)
    const [name, setName] = useState()
    const [sort, setSort] = useState(0)
    const [loading, setLoading] = useState(false)
    const [remarkPc, setRemarkPc] = useState()
    const [remarkWap, setRemarkWap] = useState()
    const [layout, setLayout] = useState(1)


    useEffect(() => {
        if (isShow) {
            if (!!data.id) {
                setName(data.name)
                setSort(data.sort)
                setRemarkPc(data.remarkPc)
                setRemarkWap(data.remarkWap)
                setLayout(data.layout)
            }
        } else {
            setName()
            setSort(0)
            setRemarkPc()
            setRemarkWap()
            setLayout(1)
        }
        setIsOpen(isShow)
    }, [isShow])

    const onRemarkPc = useCallback((url)=>{
        setRemarkPc(url)

    })
    const onRemarkWap = useCallback((url)=>{
        setRemarkWap(url)
    })

    const save = useCallback(() => {
        let validateResult = emptyValidate(name, '请填写线路名称');

        if (validateResult) {
            return;
        }

        JobFairApi.addJobFairLine({
            id:data.id,
            jobFairId: data.jobFairId,
            name,
            sort: sort||0,
            remarkPc,
            remarkWap,
            layout
        }).then(resp=>{
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                onClose({
                    id: data.id || resp.info,
                    jobFairId: data.jobFairId,
                    name,
                    sort,
                    remarkPc,
                    remarkWap,
                    layout
                })
            }
        })
    })


    return (
        <DraggableModal
            title="添加线路"
            open={isOpen}
            onOk={save}
            onCancel={() => onClose()}
            width={680}
            okText="保存"
            footer={null}
            maskClosable={false}
        >
            <div className="white-bg mgt32 pdb40 pdh32">
                <div className="gray-dark mgb8">线路名称</div>
                <Input
                    style={{width: 280}}
                    value={name}
                    placeholder="请填写"
                    maxLength={120}
                    onChange={(e) => setName(e.target.value)}/>
                <div className="gray-dark mgb8 mgt24">线路排序</div>
                <Input
                    style={{width: 280}}
                    value={sort}
                    placeholder="请填写数值(数值越大排序越前)"
                    max={10000}
                    min={0}
                    type="number"
                    onChange={(e) => setSort(e.target.value)}/>


                <div className="flexbox mgt32">
                    <div style={{width: '240px'}} >
                        <div className="gray-dark">PC端线路备注（选填）</div>
                        <div className="pdv12">
                            <PicUploader type={4} onResult={onRemarkPc}>
                                {remarkPc && <Image src={remarkPc} preview={false} style={{width: 102, height: 102}}/>}
                                {!remarkPc && <div className="gray text-center">
                                    <div className="fts-32 gray-light">+</div>
                                    <div className="gray-light fts-13">建议尺寸1920*460px</div>
                                </div>}
                            </PicUploader>
                        </div>
                    </div>
                    <div style={{width: '240px'}} className="pd12 mgl80">
                        <div className="gray-dark">WAP端线路备注（选填）</div>
                        <div className="pdv12">
                            <PicUploader type={4} onResult={onRemarkWap}>
                                {remarkWap && <Image src={remarkWap} preview={false} style={{width: 102, height: 102}}/>}
                                {!remarkWap && <div className="gray text-center">
                                    <div className="fts-32 gray-light">+</div>
                                    <div className="gray-light fts-13">建议尺寸750*360px</div>
                                </div>}
                            </PicUploader>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flexbox justifyCenter mgt24">
                <Space>
                    <Button key="submit" type="primary" loading={loading} onClick={save}>
                        保存
                    </Button>
                    <Button key="cancel" onClick={()=>onClose()}>
                        取消
                    </Button>
                </Space>
            </div>
        </DraggableModal>)
}




